import { render } from "./IncomeExpenseAccountWidget.vue?vue&type=template&id=06c0fc35"
import script from "./IncomeExpenseAccountWidget.vue?vue&type=script&lang=js"
export * from "./IncomeExpenseAccountWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__